module.exports = __webpack_public_path__ + "img/wm3.af2cffab.png";